import styled from 'styled-components';

import MenuCounter from './component';

export default styled(MenuCounter)`
  color: white;
  height: 16px;
  border-radius: 8px;
  background-color: var(--grey500);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  width: 26px;
`;
